import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateOrUpdateInternalCandidacyCommentRequest,
  HttpResponse,
  InternalCandidacyComment,
} from "@/types";

export function useUpdateInternalCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      internalCandidacyCommentId,
      updateInternalCandidacyCommentRequest,
    }: {
      candidacyId: string;
      internalCandidacyCommentId: number;
      updateInternalCandidacyCommentRequest: CreateOrUpdateInternalCandidacyCommentRequest;
    }) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/internal-candidacy-comments/${internalCandidacyCommentId}`;
      const res = await guacHttpClient.patch<
        InternalCandidacyComment,
        HttpResponse<InternalCandidacyComment>,
        CreateOrUpdateInternalCandidacyCommentRequest
      >(path, updateInternalCandidacyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
